export const LOAD_SEARCH_RESULTS = 'LOAD_SEARCH_RESULTS';
export const SET_SEARCH_STATUS = 'SET_SEARCH_STATUS';
export const SET_SEARCH_STRING = 'SET_SEARCH_STRING';
